import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";

// NOTE: CompleteRoute is rendered as a plain sibling of the MyProfile
// <Route> (see layouts/Admin.js), not inside a <Switch> keyed on path — so
// it has no idea whether the current URL is already MyProfile, and runs
// this same check on every render regardless of route. It used to respond
// to an incomplete profile with <Redirect to="/singles/my-profile/:id">,
// which fired unconditionally on every render — including immediately
// after landing on that very page — producing a redirect loop that crashed
// React ("Maximum update depth exceeded") with no error boundary to catch
// it, leaving a blank screen. Rendering a static message here instead of
// navigating avoids the loop entirely, and doubles as the "why am I stuck"
// explanation a bare redirect never gave the user anyway.
const ProfileIncompleteNotice = ({ userId }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      padding: "48px 16px",
    }}
  >
    <div
      style={{
        maxWidth: 480,
        width: "100%",
        textAlign: "center",
        background: "#ffefc1",
        border: "1px solid #f2c464",
        borderRadius: 14,
        padding: "32px 28px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >
      <strong style={{ fontSize: 20, display: "block", marginBottom: 8 }}>
        Complete your profile to continue
      </strong>
      <p style={{ margin: "0 0 20px", color: "#5f4b00", fontSize: 14 }}>
        You'll need a profile photo, at least 3 gallery photos, and an "about
        me" before you can use the rest of Beramour.
      </p>
      <Link
        to={`/singles/my-profile/${userId}`}
        style={{
          display: "inline-block",
          background: "#f2a900",
          color: "#ffffff",
          padding: "10px 24px",
          borderRadius: 10,
          fontWeight: 700,
          textDecoration: "none",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        }}
      >
        Complete my profile
      </Link>
    </div>
  </div>
);

const CompleteRoute = ({ children }) => {
  const { profileIsComplete, user, isLoading } = useAuth();
  const currentUserId = user?.user_id;
  const userRole = user?.userrole;

  // Loading state
  if (isLoading) {
    return <div>Loading profile status...</div>;
  }

  // BYPASS: marketers (role 4 or 5) don't have a completeness requirement
  const isMarketer = userRole === "4" || userRole === "5";
  if (isMarketer) {
    return <>{children}</>;
  }

  if (!profileIsComplete && currentUserId) {
    return <ProfileIncompleteNotice userId={currentUserId} />;
  }

  // Profile is complete, or there's no logged-in user yet — render children
  return <>{children}</>;
};

export default CompleteRoute;
